import { Box, Skeleton } from '@mui/material';

export const AssessmentSkeleton = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        p: { xs: 1, md: 4 },
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: ({ dimensions }) => dimensions.miniPlayer.height,
      }}>
      <Box
        sx={{
          flexBasis: '300px',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}>
        <Skeleton variant="rounded" sx={{ height: '100%' }} />
      </Box>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          maxWidth: 800,
        }}>
        <Skeleton variant="rounded" height={120} />
        <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: 'auto auto' }}>
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} variant="rounded" height={80} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};
